import React, { useState } from "react";
import "../../index.css";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import { Link } from "react-router-dom";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import carousel1 from "../../assets/img/carousel-1.webp";
import carousel2 from "../../assets/img/carousel-2.webp";
import carousel3 from "../../assets/img/carousel-3.webp";
import about from "../../assets/img/profileFundator.webp"
import Courses from "./Courses";
import Registration from "./Registration";
import TestimonialCarousel from "./TestimonialCarousel";
import PromoBar from "./PromoBar";
import CommunityBanner from "./CommunityBanner";

const Home = () => {
  // const [showModal, setShowModal] = useState(false);
  return (
    <>
      {/* Carousel Start */}
      <div className="container-fluid p-0 pb-5 mb-5">
        <Swiper
          modules={[Navigation, Pagination, Autoplay]}
          navigation
          pagination={{ clickable: true }}
          autoplay={{ delay: 3000 }}
          loop
          className="carousel-inner"
        >
          <SwiperSlide>
            <img className="position-relative w-100" src={carousel1} alt="Slide 1" />
            <div className="carousel-caption d-flex align-items-center justify-content-center">
              <div className="p-5" style={{ width: "100%", maxWidth: "900px" }}>
                <h5 className="text-white text-uppercase mb-md-3">Cursos totalmente Online</h5>
                <h1 className="display-3 text-white mb-md-4">El mundo digital avanza. ¿Tú también?</h1>
                <Link to="/courses" className="btn btn-primary py-md-2 px-md-4 font-weight-semi-bold mt-2">Quiero ver los cursos</Link>
              </div>
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <img className="position-relative w-100" src={carousel2} alt="Slide 2" />
            <div className="carousel-caption d-flex align-items-center justify-content-center">
              <div className="p-5" style={{ width: "100%", maxWidth: "900px" }}>
                <h5 className="text-white text-uppercase mb-md-3">Aprende y Genera Ingresos</h5>
                <h1 className="display-3 text-white mb-md-4">Tu próxima fuente de ingresos puede estar cerca</h1>
                <Link to="/courses" className="btn btn-primary py-md-2 px-md-4 font-weight-semi-bold mt-2">Quiero empezar ahora</Link>
              </div>
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <img className="position-relative w-100" src={carousel3} alt="Slide 3" />
            <div className="carousel-caption d-flex align-items-center justify-content-center">
              <div className="p-5" style={{ width: "100%", maxWidth: "900px" }}>
                <h5 className="text-white text-uppercase mb-md-3">Habilidades que el mercado paga</h5>
                <h1 className="display-3 text-white mb-md-4">No necesitas un título. Necesitas las habilidades correctas</h1>
                <Link to="/courses" className="btn btn-primary py-md-2 px-md-4 font-weight-semi-bold mt-2">Quiero ver los cursos</Link>
              </div>
            </div>
          </SwiperSlide>
        </Swiper>
      </div>
      {/* Carousel End */}

      {/* Hook de la academia */}
      <div>
        <PromoBar />
      </div>


      {/* Acerca de Start */}
      <div className="container-fluid py-5">
        <div className="container py-5">
          <div className="row align-items-center">
            <div className="col-lg-5 position-relative">
              <img
                className="img-fluid rounded mb-4 mb-lg-0"
                src={about}
                alt="Luis Eduardo Nieto - Fundador Dissemp Academy"
                style={{ boxShadow: "0 20px 60px rgba(0,0,0,0.15)" }}
              />
              {/* Badge flotante */}
              <div
                className="position-absolute d-flex align-items-center p-3 bg-white rounded shadow"
                style={{ bottom: "30px", right: "-10px", minWidth: "200px", zIndex: 1 }}
              >
                <div
                  className="d-flex align-items-center justify-content-center rounded-circle mr-3 flex-shrink-0"
                  style={{ width: "48px", height: "48px", background: "#007bff", minWidth: "48px" }}
                >
                  <i className="fa fa-graduation-cap text-white"></i>
                </div>
                <div>
                  <p className="m-0 font-weight-bold text-dark" style={{ fontSize: "1rem", lineHeight: 1.2 }}>+500</p>
                  <p className="m-0 text-muted" style={{ fontSize: "0.78rem" }}>estudiantes formados</p>
                </div>
              </div>
            </div>

            <div className="col-lg-7 pl-lg-5">
              <div className="mb-4">
                <h5 className="text-primary text-uppercase mb-3" style={{ letterSpacing: "5px" }}>
                  Quién está detrás
                </h5>
                <h1 style={{ lineHeight: "1.2", textAlign: "justify" }}>
                  No aprendes de una plataforma. <br />
                  <span className="text-primary">Aprendes de una persona real.</span>
                </h1>
              </div>

              <p className="text-muted mb-4" style={{ lineHeight: "1.9", fontSize: "1.02rem" }}>
                Soy <strong>Luis Eduardo Nieto</strong> — Ingeniero en Informática, estratega digital y fundador de Dissemp Academy.
                Llevo años trabajando en tecnología, marketing digital y negocios en internet, y decidí crear esta academia
                con una sola misión: <strong>enseñar lo que realmente funciona, sin relleno, sin teoría vacía.</strong>
              </p>

              {/* Tres diferenciadores rápidos */}
              <div className="row mb-4">
                {[
                  { icon: "fa-bolt", title: "Aprendizaje práctico", desc: "Cada curso está diseñado para que apliques desde la práctica." },
                  { icon: "fa-user-tie", title: "Instructor real", desc: "No bots, no IA. Aprenderás directamente de alguien con experiencia en campo." },
                  { icon: "fa-chart-line", title: "Orientado a resultados", desc: "El objetivo no es que termines el curso, sino que cambies algo en tu vida." },
                ].map((item, i) => (
                  <div key={i} className="col-sm-4 mb-3">
                    <div className="text-center p-3 rounded" style={{ background: "#f8f9fa" }}>
                      <i className={"fa " + item.icon + " text-primary mb-2"} style={{ fontSize: "1.4rem" }}></i>
                      <p className="font-weight-bold m-0 mb-1" style={{ fontSize: "0.85rem" }}>{item.title}</p>
                      <p className="text-muted m-0" style={{ fontSize: "0.78rem", lineHeight: "1.5" }}>{item.desc}</p>
                    </div>
                  </div>
                ))}
              </div>

              <Link
                to="/courses"
                className="btn btn-primary py-md-2 px-md-4 font-weight-semi-bold mt-2 mr-3"
              >
                Ver los cursos →
              </Link>
              <Link
                to="/about"
                className="btn btn-outline-primary py-md-2 px-md-4 font-weight-semi-bold mt-2"
              >
                Conocer al fundador
              </Link>
            </div>
          </div>
        </div>
      </div>
      {/* Acerca de End */}
      <Courses />
      <Registration />
      <TestimonialCarousel />
      <hr></hr>
      <CommunityBanner />
    </>
  );
};

export default Home;
